<div class="mat-typography mat-body mat-app-background">
  <ptl-forgot-password [flowConfig]="flowConfig"></ptl-forgot-password>
</div>